import React, { useState } from "react";
import { Amplify } from "aws-amplify";
import TextField from "../shared/TextField";
import Button from "../shared/Button";
import { confirmSignIn } from "aws-amplify/auth";
import "./Styles.css";
import { fetchUserAttributes, fetchAuthSession } from "aws-amplify/auth";
import { sendUserAttributeVerificationCode } from "aws-amplify/auth";
import VerifyEmail from "./VerifyEmail";
import { hasVerifiedEmail } from "../util/emailVerification";
const VerifyUser = ({ onLogin }) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [showVerify, setShowVerify] = useState(false);
  const passwordFormat = Amplify.getConfig().Auth?.Cognito?.passwordFormat;

  const completeLogin = async () => {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    localStorage.setItem(
      "auth",
      JSON.stringify({
        isSignedIn: true,
        token: idToken.toString(),
        user_type: idToken.payload["custom:user_type"],
        organization_type: idToken.payload["custom:organization_type"],
        organization_id: idToken.payload["custom:organization_id"],
      })
    );
    onLogin();
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) return;
    if (newPassword !== confirmPassword) {
      setError("Passwords does not match");
      return;
    }
    if (passwordFormat?.minLength && Array.from(newPassword).length < passwordFormat.minLength) {
      setError(`Use at least ${passwordFormat.minLength} characters for your new password.`);
      return;
    }
    try {
      const { isSignedIn } = await confirmSignIn({
        challengeResponse: newPassword,
      });

      if (isSignedIn) {
        const userAttributes = await fetchUserAttributes();
        if (hasVerifiedEmail(userAttributes)) {
          await completeLogin();
        } else {
          try {
            await sendUserAttributeVerificationCode({
              userAttributeKey: "email",
            });
            setShowVerify(true);
          } catch (err) {
            setError("Email verification could not be sent. Use the resend option to try again.");
            setShowVerify(true);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setError(error.message || "An error occurred.");
    }
  };

  return (
    <div className="w-full">
      {!showVerify && (
        <>
          <h1 className="heading mb-4" style={{ color: "#ebffff" }}>
            Choose your password
          </h1>
          <p className="mb-4">First sign-in: replace the temporary password from your invitation.</p>
          {passwordFormat?.minLength && (
            <p className="mb-4">
              Use at least {passwordFormat.minLength} characters
              {passwordFormat.requireUppercase && ", an uppercase letter"}
              {passwordFormat.requireLowercase && ", a lowercase letter"}
              {passwordFormat.requireNumbers && ", a number"}
              {passwordFormat.requireSpecialCharacters && ", a special character"}.
            </p>
          )}
          <form className="mb-4 w-full" onSubmit={handleResetPassword}>
            <TextField
              name="code"
              label="New Password"
              type="password"
              className="secondary"
              required
              onChange={(e) => {
                setError("");
                setNewPassword(e.target.value.trim());
              }}
            />
            <TextField
              name="ConfirmPassword"
              label="Confirm Password"
              type="password"
              className="secondary"
              required
              onChange={(e) => {
                setConfirmPassword(e.target.value.trim());
                setError("");
              }}
            />
            {error && <p className="error-msg">{error}</p>}
            <Button label="Submit" className="primary" type="submit" />
          </form>
        </>
      )}

      {showVerify && <VerifyEmail onLogin={onLogin} initialError={error} />}
    </div>
  );
};

export default VerifyUser;
